import { createFileRoute } from '@tanstack/react-router';
import { dashboardQuery, sectionsQuery } from '@/features/constructor/api';
import { DashboardViewerPage } from '@/features/constructor/viewer/DashboardViewerPage';

/** "Bosh panel" — the tenant dashboard viewer (14:7285), full-bleed, outside the app shell. */
export const Route = createFileRoute('/_authed/t/$tenantSlug/')({
  loader: ({ context }) => {
    // warm the cache; the page renders its own loading state, so navigation is not blocked
    void context.queryClient.prefetchQuery(dashboardQuery(context.tenant.id));
    void context.queryClient.prefetchQuery(sectionsQuery(context.tenant.id));
  },
  component: DashboardViewerRoute,
});

function DashboardViewerRoute() {
  const { tenant } = Route.useRouteContext();
  return <DashboardViewerPage tenant={tenant} />;
}
